<template>
    <div>
        <!-- <label >{{Item.name}}</label> -->
        <label v-if=(Item.hits)>{{Item.hits}}</label>
        <md-field style="margin-top:0px;padding-top:0px">
            <md-select v-model=Item.value class="formInput" :placeholder=Item.name :readonly="readonly">
                <md-option v-for="option in Item.option" :key="option.key" :value=option.key @change="checkEdited($event)" >{{option.name}}</md-option>
            </md-select>
        </md-field>
    </div>
  </template>
  <script>
  export default {
    methods:{
      checkEdited:function(event){
        consent.log("checkEdited");
          console.log(event);
          //this.$emit("checkEdited", true);
        },
    },
    name: "select-input-component",
    props: {
        Item:{
          default() {
              return {};
          },
        },
        readonly:{
          default: false,
        },
    },
    data() {
      return {
      };
    },
    computed: {
  
    }
  };
  </script>
  <style>
    .md-menu-content{
      width: auto !important;
      max-width: 500px !important;
    }
  </style>